'use client'

import Page404 from './404/page'

export default function NotFound() {
  return (
    <Page404 />
  )
}
